import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Base64 } from 'js-base64';
import Barcode from './Barcode';
import numberFormat from '../../utils/numberFormat';
import { sendEventLog } from '../../utils/newTiaraUtil';
import { fetchWithJson } from '../../utils/api';
import { STATUS_REGISTERED } from '../../reducers/membership';
import queryString from 'query-string';

export default class Membership extends Component {
  constructor(props) {
    super(props);
    this.handleRegisterCard = this.handleRegisterCard.bind(this);
    this.renderBenefit = this.renderBenefit.bind(this);

    this.handleTestUnlink = this.handleTestUnlink.bind(this);
    this.handleTestUnlinkFriends = this.handleTestUnlinkFriends.bind(this);
    this.renderTestView = this.renderTestView.bind(this);
  }

  componentDidMount() {
    const { history, location } = this.props;
    if (location.search) {
      const params = queryString.parse(location.search);

      if (params.from && params.from === 'signup_complete') {
        history.go(-2);
      }
    }
  }

  handleRegisterCard() {
    const { profileId, membership, location: { search } } = this.props;
    sendEventLog('register_card');

    let from = '';
    if (search) {
      const params = queryString.parse(search);
      from = params.from || '';
    }
    const restApiKey = membership.get('restApiKey');
    const authRedirectUrl = membership.get('authRedirectUrl');
    const stateData = {
      signup_source: 'membership',
      source_redirect_url: `${process.env.REACT_APP_MEMBERSHIP_HOST}/profiles/${profileId}/card?from=signup_complete&referer_source=${from}`
    };
    const stateBase64 = Base64.encode(JSON.stringify(stateData));
    const authUrl = `${process.env.REACT_APP_KAUTH_URL}/oauth/authorize?client_id=${restApiKey}&redirect_uri=${encodeURIComponent(authRedirectUrl)}&state=${stateBase64}&response_type=code&encode_state=true`;
    location.href = authUrl;
  }

  handleTestUnlink() {
    const { profileId, fetchMembership } = this.props;
    fetchWithJson(`/api/membership/${profileId}/unlink`)
      .then(() => {
        fetchMembership(profileId);
      })
    ;
  }

  handleTestUnlinkFriends() {
    const { profileId, fetchMembership } = this.props;
    fetchWithJson(`/api/membership/${profileId}/unlink/friends`)
      .then(() => {
        fetchMembership(profileId);
      })
    ;
  }

  renderTestView() {
    const { membership } = this.props;
    const time = new Date(membership.get('timestamp', 0)).toString();
    return (
      <div>
        <br />
        <span>{time}</span><br />
        <span> your accountId: {membership.get('accountId', 'none')}</span><br />
        <button type="button" onClick={this.handleTestUnlink}>[ Unlink & Unfriend!! ]</button><br />
        <button type="button" onClick={this.handleTestUnlinkFriends}>[ Unlink Friends!! ]</button>
      </div>
    );
  }

  renderBenefit() {
    const { phase } = this.props;
    const isTestMode = phase === 'sandbox';
    const isBenefitDateOver = new Date() > new Date('2019-03-01T00:00:00+09:00');
    return (
      <div className="benefit_cont">
        <h2 className="tit_benefit">멤버십 혜택</h2>
        <span className="txt_benefit">
          가입 시 웰컴 포인트 1000P 지급<br />
          {isBenefitDateOver ? '결제 금액의 3% 적립' : '결제 금액의 6% 적립(~19.02.28)'}<br />
          결제 시 멤버십 포인트 사용 가능
          {/* TEST CODE */}
          {isTestMode && this.renderTestView()}
        </span>
      </div>
    );
  }

  render() {
    const { membership } = this.props;
    const status = membership.get('status');
    const barcodeNumber = membership.get('memberCardNo', '');
    const point = membership.get('availablePoint', 0);
    const isRegistered = status === STATUS_REGISTERED;
    const barcodeNumberPretty = barcodeNumber.split(/(.{4})/).filter(s => !!s).reduce((a, b) => `${a} ${b}`, '');

    return (
      <div>
        <header id="kakaoHead" className="head_membership">
          <h1 className="logo_membership">카카오프렌즈<span className="ico_sync ico_membership">membership</span></h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <div className="wrap_barcode">
              <div className="barcode_cont">
                <Barcode value={barcodeNumber}/>
                <span className="txt_barcode">{barcodeNumberPretty}</span>
              </div>
              <div className="info_cont">
                <h2 className="screen_out">포인트</h2>
                {!isRegistered && (
                  <button type="button" name="register_card" className="btn_apply" onClick={this.handleRegisterCard}>등록하기</button>
                )}
                {isRegistered && (
                  <span className="logo_brand">
                    <img className="logo_img" alt=""/>
                  </span>
                )}
                <div className="point_info">
                  <span className="txt_point">
                    {numberFormat(point)}
                    <span className="ico_sync ico_point">P</span>
                  </span>
                  {!isRegistered && (<span className="txt_sub">멤버십 등록 후 포인트를 사용하세요</span>)}
                </div>
              </div>
              <img className="img_animation" alt="" />
            </div>
            {this.renderBenefit()}
            <button type="button" name="main_close" className="ico_sync btn_close" onClick={this.props.onClose}>닫기</button>
          </article>
        </main>
      </div>
    );
  }
}

Membership.propTypes = {
  device: PropTypes.object.isRequired,
  membership: PropTypes.object.isRequired,
  profileId: PropTypes.string.isRequired,
  fetchMembership: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase:  PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Membership/index.js